import type { ReactNode, JSX } from 'react'
import { TbChevronDown } from 'react-icons/tb'
import clsx from 'clsx'
import { Stack, StackProps } from '../stack/stack'

type AccordionContentProps = Pick<
  StackProps,
  'className' | 'gap' | 'row' | 'wrap'
>

type AccordionProps = {
  className?: string
  children: ReactNode

  title: string | JSX.Element

  /**
   * Accordion content is a `Stack` component, this expose properties on that
   *  component to allow for customization
   */
  contentProps?: AccordionContentProps
  open?: boolean
}

export const Accordion = ({
  className,
  title,
  children,
  contentProps = { gap: 0 },
  open,
}: AccordionProps) => {
  return (
    <details className={clsx(className, 'accordion')} open={open}>
      <summary>
        <span className="accordion-label">{title}</span>
        <TbChevronDown aria-hidden="true" />
      </summary>
      <Stack
        {...contentProps}
        className={clsx('accordion-content', contentProps.className)}
      >
        {children}
      </Stack>
    </details>
  )
}
